module.exports = __webpack_public_path__ + "static/media/ClearMoon01n.8a25ba4b.png";